// Slate external packages
import EditList from '@productboard/slate-edit-list'
// import EditList from './front-slate-edit-list'
// import EditList from '../../../../../node_modules/front-slate-edit-list/lib'
// import EditList from 'slate-edit-list'
// import EditList from 'front-slate-edit-list'

import PasteLinkify from 'slate-paste-linkify'
import SoftBreak from 'slate-soft-break'
import AutoReplace from 'slate-auto-replace'
// import TrailingBlock from 'slate-trailing-block'
// import InsertBlockOnEnter from 'slate-insert-block-on-enter'

// Custom plugins
import EditBlockquote from '@guestbell/slate-edit-blockquote' // https://github.com/guestbell/slate-plugins
import EditListExtended from './EditListExtended'
import KeyHandling from './KeyHandling'
import ForceRefresh from './ForceRefresh'
import HtmlPaste from './HtmlPaste'
import InsertEmbed from './InsertEmbed'

import CodeBlock from './SlateCodeBlock' // https://github.com/cdunn/slate-code-block
// https://github.com/grafana/grafana/blob/master/packages/grafana-ui/src/slate-plugins/slate-prism/index.ts
import { SlatePrism } from './SlatePrism' // https://github.com/ChrisBrownie55/slate-prism

const isOuterBlock = editor =>
	editor.value.document.getParent(editor.value.focusBlock.key).object ===
	'document'
const isParagraph = editor => editor.value.focusBlock.type === 'paragraph'
const isEmpty = editor => editor.value.focusBlock.text.length === 0

const plugins = [
	InsertEmbed(),
	ForceRefresh(),
	EditBlockquote({
		type: 'block-quote',
		typeDefault: 'paragraph',
	}),
	EditBlockquote({
		type: 'hint',
		typeDefault: 'paragraph',
	}),
	CodeBlock({
		containerType: 'code_block',
		lineType: 'code_line',
	}),
	SlatePrism({
		getSyntax: node => node.data.get('language') || 'javascript',
		onlyIn: node => node.object === 'block' && node.type === 'code_block',
	}),
	PasteLinkify(),
	SoftBreak({ shift: true }),
	// InsertBlockOnEnter('paragraph'),
	// TrailingBlock({ type: 'paragraph' }),
	EditList({
		// types: ['ordered-list', 'bulleted-list'],
		types: ['numbered-list', 'bulleted-list'],
		typeItem: 'list-item',
		typeDefault: 'paragraph',
	}),
	// https://github.com/ianstormtaylor/slate-plugins/tree/master/packages/slate-auto-replace
	// Blockquote
	AutoReplace({
		// ignoreIn: CODE_BLOCK,
		trigger: 'space',
		before: /^(>)$/,
		change: (editor, e, matches) => {
			if (isOuterBlock(editor)) {
				editor.setBlocks('block-quote')
			} else {
				editor.insertText(`${matches.before.input} `)
			}
		},
	}),
	// Bulleted list
	AutoReplace({
		trigger: 'space',
		before: /^(-)$/,
		change: (editor, e, matches) => {
			if (isOuterBlock(editor)) {
				editor.setBlocks('list-item').wrapBlock('bulleted-list')
			} else {
				editor.insertText(`${matches.before.input} `)
			}
		},
	}),
	// Bulleted list
	AutoReplace({
		trigger: 'space',
		before: /^(\*)$/,
		change: (editor, e, matches) => {
			if (isOuterBlock(editor)) {
				editor.setBlocks('list-item').wrapBlock('bulleted-list')
			} else {
				editor.insertText(`${matches.before.input} `)
			}
		},
	}),
	// Bulleted list
	AutoReplace({
		trigger: 'space',
		before: /^(\+)$/,
		change: (editor, e, matches) => {
			if (isOuterBlock(editor)) {
				editor.setBlocks('list-item').wrapBlock('bulleted-list')
			} else {
				editor.insertText(`${matches.before.input} `)
			}
		},
	}),
	// Numbered list
	AutoReplace({
		trigger: 'space',
		before: /^(1\.)$/,
		change: (editor, e, matches) => {
			if (isOuterBlock(editor)) {
				editor.setBlocks('list-item').wrapBlock('numbered-list')
			} else {
				editor.insertText(`${matches.before.input} `)
			}
		},
	}),
	// Horizontal line
	AutoReplace({
		trigger: 'enter',
		before: /^(-{3})$/,
		after: /^$/,
		change: (editor, e, matches) => {
			if (isOuterBlock(editor)) {
				editor
					.setBlocks({ type: 'hr', isVoid: true })
					.insertBlock('paragraph')
			} else {
				editor.insertText(`${matches.before.input}`)
			}
		},
	}),
	AutoReplace({
		trigger: 'space',
		before: /^(-{3})$/,
		after: /^$/,
		change: (editor, e, matches) => {
			if (isOuterBlock(editor)) {
				editor
					.setBlocks({ type: 'hr', isVoid: true })
					.insertBlock('paragraph')
			} else {
				editor.insertText(`${matches.before.input} `)
			}
		},
	}),

	// H1
	AutoReplace({
		trigger: 'space',
		before: /^(#)$/,
		change: (editor, e, matches) => {
			if (isOuterBlock(editor)) {
				editor.command('setH2')
			} else {
				editor.insertText(`${matches.before.input} `)
			}
		},
	}),
	// H2
	AutoReplace({
		trigger: 'space',
		before: /^(##)$/,
		change: (editor, e, matches) => {
			if (isOuterBlock(editor)) {
				editor.command('setH3')
			} else {
				editor.insertText(`${matches.before.input} `)
			}
		},
	}),

	// AutoReplace({
	// 	trigger: 'space',
	// 	before: /^(#{1,6})$/,
	// 	change: (change, event, matches) => {
	// 		const [hashes] = matches.before
	// 		const level = hashes.length

	// 		change.setBlocks({ type: 'h', data: { level } })
	// 	},
	// }),
	HtmlPaste(),
	KeyHandling(),
	EditListExtended(),
]

export default plugins
